import React from "react";
import PropTypes from "prop-types";
import { formatTaskDate } from "../../utils/form";
import styles from "./styles.module.scss";

const TaskDate = React.memo(({ label, date }) => {
  return (
    <div>
      <span className={styles.taskDateLabel}>{label}</span>
      <span>{formatTaskDate(date)}</span>
    </div>
  );
});

TaskDate.propTypes = {
  label: PropTypes.string,
  date:  PropTypes.string,
};
TaskDate.displayName = "TaskDate";

export default TaskDate;
